var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c("div", { staticClass: "tag-sections" }, [
      _c(
        "section",
        { staticClass: "tag" },
        [
          _c("CharacteristicSelectInline", {
            attrs: {
              "characteristic-items": _vm.meta.employmentMode,
              "initial-show-all": "",
              "show-multiple-hint": "",
              "label-type": "job-profile"
            },
            on: { input: _vm.emitChangeEvent },
            model: {
              value: _vm.employmentModes,
              callback: function($$v) {
                _vm.employmentModes = $$v
              },
              expression: "employmentModes"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "tag" },
        [
          _c("h2", [_vm._v("Sind spezielle Arbeitszeiten erforderlich?")]),
          _vm._v(" "),
          _c("CharacteristicSelectInline", {
            attrs: {
              "nothing-allowed": {
                text: "Nein, keine speziellen Arbeitszeiten"
              },
              "characteristic-items": _vm.meta.workingTime,
              "initial-show-all": "",
              "show-multiple-hint": "",
              "label-type": "job-profile"
            },
            on: { input: _vm.emitChangeEvent },
            model: {
              value: _vm.workingTimes,
              callback: function($$v) {
                _vm.workingTimes = $$v
              },
              expression: "workingTimes"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }